module.exports = __webpack_public_path__ + "assets/favicons/favicon-96x96.png";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=assets/favicons/[name].[ext]!./client/app/assets/favicons/favicon-96x96.png
// module id = 1238
// module chunks = 1